<template>
	<div class="page-container">
		<md-app md-mode="fixed">
			<md-app-toolbar class="md-primary">
				<md-button class="md-icon-button" @click="backHome()">
					<md-icon>arrow_back</md-icon>
				</md-button>
				<span v-if="!betNotFound" class="md-title" style="font-size: 15px; font-weight: bold;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 240px; margin-left: 0;">
					Bilhete: {{ bet.eticket }}
				</span>
			</md-app-toolbar>
			<md-app-content style="padding: 5px;padding-top: 0px;">
				<md-empty-state style="color: black;"  class="no-event-found"
				md-icon="sentiment_very_dissatisfied" v-if="betNotFound"
				:md-label="msg">
				<md-button class="md-raised md-accent" v-on:click="backHome()">
					VOLTAR
				</md-button>
				</md-empty-state>
				<div class="md-layout md-gutter md-alignment-center-center" v-if="loadingBet">
					<img class="titan-logo" src="../assets/loading.gif" style="width: 90px;">
				</div>
				<div v-if="!loadingBet && !betNotFound" class="fundo-ticket-number zig-zag-top zig-zag-bottom">
					<div class="md-layout">
						<div class="md-layout-item logo">
							<img class="titan-logo" src="../assets/titan_logo.png">
						</div>
					</div>
					<div class="md-layout">
						<div class="md-layout-item" style="padding-left: 10px; padding-right: 10px; margin-top: 10px;">
							<div class="md-layout fundo-ticket-number-even" style="border: 1px solid black; padding: 0; ">
								<table style="width: 100%;">
									<tr>
										<td style="width: 50%;border-right: 1px solid black;">
											<div class="md-layout-item md-size-100" style="font-size: 12px;">Número:</div>
											<div class="md-layout-item" style="text-align: center;font-size: 18px;">{{ bet.eticket }}</div>
										</td>
										<td>
											<div class="md-layout-item md-size-100" style="font-size: 12px;">Data:</div>
											<div class="md-layout-item" style="text-align: center;font-size: 17px;">{{ bet.date }}</div>
										</td>
									</tr>
								</table>
							</div>
							<div class="md-layout fundo-ticket-number-even" style="border: 1px solid black; padding: 0; border-top: 0;">
								<table style="width: 100%;">
									<tr>
										<td style="width: 50%;border-right: 1px solid black;">
											<div class="md-layout-item md-size-100" style="font-size: 12px;">Valor Apostado:</div>
											<div class="md-layout-item" style="text-align: center;font-size: 18px;">{{ bet.value }}</div>
										</td>
										<td>
											<div class="md-layout-item md-size-100" style="font-size: 12px;">Apostador:</div>
											<div class="md-layout-item" style="text-align: center;font-size: 18px;">{{ bet.punter }}</div>
										</td>
									</tr>
								</table>
							</div>
							<div class="md-layout fundo-ticket-number-even" style="border: 1px solid black; padding: 0; border-top: 0;">
								<table style="width: 100%;">
									<tr>
										<td style="width: 50%;border-right: 1px solid black;">
											<div class="md-layout-item md-size-100" style="font-size: 12px;">Eventos:</div>
											<div class="md-layout-item" style="text-align: center;font-size: 18px;">{{ bet.selectedSubevents.length }}</div>
										</td>
										<td>
											<div class="md-layout-item md-size-100" style="font-size: 12px;">Possível Retorno:</div>
											<div class="md-layout-item" style="text-align: center;font-size: 18px;">{{ bet.possible_return }}</div>
										</td>
									</tr>
								</table>
							</div>
							<div v-if="bet.possible_return_seller > 0" class="md-layout fundo-ticket-number-even" style="border: 1px solid black; padding: 0; border-top: 0;">
                  <table style="width: 100%;">
                      <tr>
                          <td style="width: 50%;border-right: 1px solid black;">
                              <div class="md-layout-item md-size-100" style="font-size: 12px;">Bonificação Colaborador:</div>
                              <div class="md-layout-item" style="text-align: center;font-size: 18px;">{{ bet.possible_return_seller }}</div>
                          </td>
                          <td>
                              <div class="md-layout-item md-size-100" style="font-size: 12px;">Prêmio Líquido Cliente:</div>
                              <div class="md-layout-item" style="text-align: center;font-size: 18px;">{{ bet.possible_return_liquid }}</div>
                          </td>
                      </tr>
                  </table>
              </div>
							<div class="md-layout fundo-ticket-number-even" style="border: 1px solid black; padding: 0; border-top: 0;">
								<table style="width: 100%;">
									<tr>
										<td style="width: 50%;border-right: 1px solid black;">
											<div class="md-layout-item md-size-100" style="font-size: 12px;">Status:</div>
											<div class="md-layout-item" style="text-align: center;font-size: 18px;" v-bind:class="verifyColorStatus(bet.status)">{{ bet.status }}</div>
										</td>
										<td>
										</td>
									</tr>
								</table>
							</div>

							<!-- <div class="md-layout fundo-ticket-number-even">
								<div class="md-layout-item md-size-40">Número:</div>
								<div class="md-layout-item" style="text-align: right;">{{ bet.eticket }}</div>
							</div>
							<div class="md-layout fundo-ticket-number-odd">
								<div class="md-layout-item md-size-40">Valor Apostado:</div>
								<div class="md-layout-item" style="text-align: right;">{{ bet.value }}</div>
							</div>
							<div class="md-layout fundo-ticket-number-even">
								<div class="md-layout-item md-size-50">Possível Retorno:</div>
								<div class="md-layout-item" style="text-align: right;">{{ bet.possible_return }}</div>
							</div>
							<div class="md-layout fundo-ticket-number-odd">
								<div class="md-layout-item md-size-40">Eventos:</div>
								<div class="md-layout-item" style="text-align: right;">{{ bet.selectedSubevents.length }}</div>
							</div>
							<div class="md-layout fundo-ticket-number-even">
								<div class="md-layout-item md-size-40">Data:</div>
								<div class="md-layout-item" style="text-align: right;">{{ bet.date }}</div>
							</div>
							<div class="md-layout fundo-ticket-number-odd">
								<div class="md-layout-item md-size-40">Apostador:</div>
								<div class="md-layout-item" style="text-align: right;">{{ bet.punter }}</div>
							</div>
							<div class="md-layout fundo-ticket-number-even">
								<div class="md-layout-item md-size-40">Status:</div>
								<div class="md-layout-item" style="text-align: right;" v-bind:class="verifyColorStatus(bet.status)">{{ bet.status }}</div>
							</div> -->
							<div class="md-layout">
								<div class="md-layout-item" style="text-align: center; font-weight: bold;">Apostas</div>
							</div>
							<div class="md-layout" v-for="(subevento, key) in bet.selectedSubevents" v-bind:class="verifyOddEven(key)">
								<div class="md-layout-item" style="padding-top: 3px; padding-bottom: 3px; text-align: center;">
									<div class="md-layout">
										<div class="md-layout-item">{{ subevento.schedule }}</div>
									</div>
									<div class="md-layout">
										<div class="md-layout-item">{{ subevento.league }}</div>
									</div>
									<div class="md-layout">
										<div class="md-layout-item">{{ subevento.tituloEvento }}</div>
									</div>
									<div class="md-layout">
										<div class="md-layout-item">{{ subevento.tituloSubEvento }}: {{ subevento.label }} - {{ subevento.cotacao }}</div>
									</div>
									<div class="md-layout tempoReal" v-if="subevento.tempoReal">
										<div class="md-layout-item status-pendente-text">{{ subevento.tempoReal.placar }} ({{ subevento.tempoReal.timer }}<span v-if="subevento.tempoReal.timer != 'Encerrado'"class="blinktimer">'</span>)</div>
									</div>
									<div class="md-layout tempoReal" v-if="subevento.tempoReal">
										<div class="md-layout-item status-pendente-text">Escanteios: {{ subevento.tempoReal.escanteios }} </div>
									</div>
									<div class="md-layout tempoReal" v-if="!(subevento.tempoReal) && subevento.timer == 'Encerrado'">
										<div class="md-layout-item status-pendente-text">{{ subevento.placar }} ({{ subevento.timer }})</div>
									</div>
									<div class="md-layout tempoReal" v-if="!(subevento.tempoReal) && subevento.timer == 'Encerrado' && subevento.escanteios">
										<div class="md-layout-item status-pendente-text">Escanteios: {{ subevento.escanteios }} </div>
									</div>
									<div class="md-layout">
										<div v-if="!(subevento.tempoReal) || subevento.tempoReal.timer == 'Encerrado'" class="md-layout-item" v-bind:class="verifyColorStatus(statusSubevento(subevento))">{{ statusSubevento(subevento) }}</div>
										<div v-if="(subevento.tempoReal) && subevento.tempoReal.timer != 'Encerrado'" class="md-layout-item blinktimer" v-bind:class="verifyColorStatus(statusSubevento(subevento))">{{ statusSubevento(subevento) }}</div>
									</div>
								</div>
							</div>
							<!-- <div class="md-layout">
								<div class="md-layout-item" style="padding-top: 3px; padding-bottom: 3px; text-align: center; color: white; font-weight: bold;">
									Caso haja atraso no pagamento do prêmio, entre em contato através do nosso WhatsApp: <br> (98) 98135-5075
								</div>
							</div> -->
							<qrcode-vue :value="id" :size="size" level="H" style="text-align: center; margin-top: 10px; margin-bottom: 10px;"></qrcode-vue>
							<div v-if="bet.pix == 's'" class="md-layout-item" style="padding-left: 10px; padding-right: 10px; margin-top: 10px;">
                                <md-button class="md-raised md-primary" style="color: white !important; background-color: green; width: 95%;" @click="share()">
                                  <md-icon style="color: white; ">whatsapp</md-icon>
                                  Salve o link no WhatsApp!
                                </md-button>
                            </div>
							<div class="md-layout">
								<div class="md-layout-item" style="padding-top: 3px; padding-bottom: 3px; text-align: center; color: white; font-weight: bold;">
									Leia as regras em nosso site. <br> Acesse: <a href="https://esportemania.info/" style="color: white;">https://esportemania.info/</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</md-app-content>
		</md-app>
	</div>
</template>
<script>

	import axios from 'axios'
	import QrcodeVue from 'qrcode.vue';

	export default {
		name: 'TitanReprint',
		components: {
			QrcodeVue
		},
		data () {
			return {
				id: 0,
				loadingBet: true,
				betNotFound: false,
				bet: {},
				size: 150
			}
		},
        created() {
            this.id = this.$route.params.id;
        },
        methods: {
        	backHome: function() {
        		this.$router.go(-1)
        	},
			share: function() {
                window.open("https://wa.me/553497157920?text=Acompanhe%20seu%20bilhete%20em%20https://esportemania.info/%23/reprint/" + this.id + ".%20Boa%20sorte!");
            },
        	verifyOddEven: function(key) {
				return {
					'fundo-ticket-number-odd': (key % 2 == 0),
					'fundo-ticket-number-even': (key % 2 != 0)
				}
			},
			verifyColorStatus: function(status) {
				return {
					'status-pendente-text': (status == 'Pendente'),
					'status-win-text': (status == 'Ganhou' || status == 'Ganhando'),
					'status-lose-text': (status == 'Perdeu' || status == 'Perdendo'),
					'status-canceled-text': (status == 'Cancelada'),
					'status-closed-text': (status == 'Encerrado'),
					'status-closed-text': (status == 'Encerrada')
				}
			},
			statusSubevento: function(subevento) {
				if (subevento.tempoReal) {
					return subevento.tempoReal.status
				}
				else {
					return subevento.nomeStatus
				}
			},
			statusBet: function(bet) {

			},
	        getTicket() {
	        	if (this.id == 0) return false;

	        	var config = {
				  headers: {}
				};

	        	axios
				.get(this.$root.$data.API_URL + 'trackbet/' + this.id, config)
				.then(response => {
					//console.log(response.data);
					if (response.data.success) {
		        		this.bet = response.data.bet
		        	} else {
		        		this.betNotFound = true
		        		this.msg = response.data.message
		        	}
		        })
				.finally(() => this.loadingBet = false );

	        },
	        track() {
	        	var t = this
	        	t.getTicket()
	        	setTimeout(function() {
	        		console.log('ok');
	        		t.track()
	        	}, 30000);
	        }
        },
        mounted() {
        	this.track();
        }
	}
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine"; // Import the theme engine

@include md-register-theme("default", (
	primary: #000000, // The primary color of your brand
	accent: #CB1323 // The secondary color of your brand
	));

@import "~vue-material/dist/theme/all"; // Apply the theme

.logo {
	text-align: center;
	margin-top: 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/TitanReprint.vue